// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"6bf8a6a08eab8c34bbea","418":"eccc4bb7484e7cd73507","661":"78e8cc0e904b33e02d0b"}[chunkId] + ".bundle.js";
};